import WazeWikiBadge from "../../components/waze-wiki-badge";

<template>
  {{#if @outletArgs.topic.first_post_wiki}}
    <WazeWikiBadge class="wiki-badge-search-results-topic-title-suffix" />
  {{/if}}
</template>
